var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-group"},[_c('label',{on:{"click":_vm.focus}},[_vm._v(_vm._s(_vm.label))]),(_vm.isAllowed)?_vm._t("default"):_c('div',{staticClass:"readonly"},[(_vm.value)?_c('span',[_vm._v(_vm._s(_vm.value))]):_c('span',[_vm._v("-")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }